module.exports = __webpack_public_path__ + "38d076cc7012dbbadb20180002d5a0e3.pdf";